import { inject, Injectable } from '@angular/core';
import { IProductDataV2, Product } from '@df/catalog/product/product';
import { ProductResource } from '@df/catalog/product/product.resource';
import {
    IRelatedProductsCallback,
    IRelatedProductsOptions,
    IRelatedProductsOptionsExtended,
    RelatedProductsService
} from '@df/catalog-ui/related-products/related-products.service';
import { Meta } from '@df/core/meta/meta';
import { NgInject } from '@df/ng/ng-inject';
import shuffle from 'lodash-es/shuffle';
import { LocalProduct } from '../../model/product/product.decorator';
export interface IColorFindEngineOptions extends IRelatedProductsOptionsExtended<LocalProduct> {
    filter: any;
    limit?: number;
}

@Injectable({
    providedIn: 'root'
})
export class ColorFindEngine {
    private productResource = inject(ProductResource);

    private meta = inject(Meta);

    get(ids: number[], cb: IRelatedProductsCallback, engineOptions: IColorFindEngineOptions, options: IRelatedProductsOptions) {
        const currentModel = <Product<IProductDataV2>>this.meta.model;
        let color: number | undefined = undefined;
        if (currentModel?.data?.color_org) {
            color = currentModel.data.color_org;
        } else if (currentModel?.data?.color) {
            color = Array.isArray(currentModel?.data?.color) ? currentModel?.data?.color[0] : currentModel?.data?.color;
        }
        if (color) {
            this.productResource
                .find({
                    filter: {
                        color: color
                    },
                    verbosity: 2,
                    limit: engineOptions.limit
                })
                .then((items: Product[]) => {
                    cb(shuffle(items.map(i => i.id)));
                });
        } else {
            cb([]);
        }
    }
}
RelatedProductsService.registerEngine('colorFind', ColorFindEngine);
